import { Get, Post } from "../Request";

export default {
  state: {
    Polls: [],
  },
  getters: {
    GetPolls(state) {
      return state.Polls;
    },
  },
  actions: {
    async GetALLPolls({ commit }, payload) {
      return await Get("Poll/GetPolls", payload).then((res) => {
        commit("SetAllPolls", res.data.Data);
        return res.data.Data;
      });
    },
    // eslint-disable-next-line no-unused-vars
    async AddPoll({ commit }, payload) {
      return await Post("Poll/AddPoll", payload).then((res) => {
        return res.data;
      });
    },
  },
  mutations: {
    SetAllPolls(state, payload) {
      state.Polls = payload;
    },
  },
};
